import { useEffect, useRef } from 'react';

export const KEYS = {
    ESCAPE: 'Escape',
};

export default function useKeyListener(keyName, callback, options) {
    const { eventName = 'keyup', targetEl = document.body } = options || {};

    const callbackRef = useRef();
    callbackRef.current = callback;

    useEffect(() => {
        if (!targetEl) {
            return;
        }

        targetEl.addEventListener(eventName, listener);

        return () => {
            targetEl.removeEventListener(eventName, listener);
        };

        function listener(event) {
            const { key } = event;

            if (key === keyName && callbackRef.current) {
                callbackRef.current(event);
            }
        }
    }, [targetEl, eventName, keyName]);
}
